import { INavigateKey } from '~/types/navigate';
import { ROUTE_PATH } from '~/config/navigate';

export const SEARCH_PARAM_KEYS = [
  'shop',
  'session',
  'hmac',
  'host',
  'embedded',
  'id_token',
  'locale',
  'timestamp',
];
export const DEFAULT_LOCATION_BACK = ROUTE_PATH[INavigateKey.Home];
